import { Circle, Settings } from 'react-feather';

// permission modules
import modules from '@src/service/modules';

export default [
    {
        id: 'settings',
        title: 'Settings',
        icon: <Settings size={20} />,
        dbId: modules.setup,
        children: [
            {
                id: 'configuration',
                title: 'Configuration',
                icon: <Circle size={12} />,
                navLink: '/settings/configuration'
                // dbId: modules.setup_role
            }
        ]
    }
];
